import * as React from "react";

export default function IntroLandning(props: any) {
    return (
        <div className="IntroLandning">
            <div className="container IntroLandning__bg">
                <img className="IntroLandning__bg__bg1" src="/assets/images/background/rectangle2.svg" alt=""/>
                <img className="IntroLandning__bg__bg2" src="/assets/images/background/rectangle1.svg" alt=""/>
                <img className="IntroLandning__bg__bg3" src="/assets/images/background/circle.svg" alt=""/>
                <div className="row">
                    <div className="col-md-6 col-xs-12">
                        <div className='IntroLandning__left'>
                            <div className='IntroLandning__left__content'>
                                <p className='IntroLandning__above'>We believe the single best way to <b>learn to code</b> is to <i>deal with code!</i></p>
                                <p>Learn Java, Scala, and technologies based on the Java Virtual Machine by reading and writing actual code. No setup, no hassle, just focus.</p>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6 col-xs-12">
                        <div className='IntroLandning__right-img' />
                    </div>
                </div>
            </div>
        </div>
    )
}


// WEBPACK FOOTER //
// ./src/components/homepage/IntroLandning.tsx